export default {
  translation: {}
}
